import { get, writable } from 'svelte/store';

export const entityNameStore = writable({});

export const cacheEntityName = (uuid, name) => {
  if (get(entityNameStore)[uuid] === name) {
    return;
  }
  entityNameStore.update((entityNames) => ({ ...entityNames, [uuid]: name }));
};
